import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import Datetime from 'react-datetime'
import "react-datetime/css/react-datetime.css";
import TimePicker from 'react-gradient-timepicker';
var Spinner = require('react-spinkit');
import DrawsCard from './KnockoutCard'
import KnockoutView from './knockoutView'
import Modal from 'react-modal';
import {isIOS, isSafari, isMobile,isTablet, isBrowser} from 'react-device-detect';
import {
  colors, shadows, btn, card, form, table, page,
} from '../../../../style/common/partnerStyle';
import {
  IconArrowLeft, IconList, IconBracket, IconTrophy,
} from '../viewFixtureScreen/icons';

// ─── Design tokens (same as ScoreboardDialogs) ───────────────────────────────
var PURPLE = "#7c3aed";
var FF     = "'DM Sans','Segoe UI',system-ui,sans-serif";

var EVENT_META = {
  "Goal":        { emoji: "⚽", color: "#16a34a", bg: "#dcfce7", border: "#86efac" },
  "Self goal":   { emoji: "🔙", color: "#dc2626", bg: "#fee2e2", border: "#fca5a5" },
  "Yellow card": { emoji: "🟡", color: "#ca8a04", bg: "#fef9c3", border: "#fde047" },
  "Red card":    { emoji: "🟥", color: "#dc2626", bg: "#fee2e2", border: "#fca5a5" },
  "Assist":      { emoji: "🎯", color: "#2563eb", bg: "#dbeafe", border: "#93c5fd" },
};
function getEventMeta(name) {
  return EVENT_META[name] || { emoji: "📌", color: "#6b7280", bg: "#f3f4f6", border: "#d1d5db" };
}
function getEventIcon(name) {
  switch (name) {
    case "Goal":        return require("../../../../img/goal.png");
    case "Self goal":   return require("../../../../img/self.png");
    case "Yellow card": return require("../../../../img/yellow.png");
    case "Red card":    return require("../../../../img/red.png");
    default:            return require("../../../../img/assist.png");
  }
}

const customStyles = {
  content : { top: '15%', left: '25%', right: '20%', bottom: 'auto' },
  overlay: { background: "rgba(52, 52, 52, 0.8)", overflow: 'hidden', position: 'fixed', zIndex: '15' }
};

class viewKnockoutScreen extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id: this.props.match.params.id,
      levels: [],
      fixtures: [],
      selected_fixture: '',
      openUpdatePopup: false,
      courts: [],
      selected_fixture_index: '',
      competition_game: '',
      openPopupFootballScoreScreen: false,
      leftOpen: false,
      rightOpen: false,
      selectedEvent: '',
      openPlayerList: false,
      teamSide: '',
      footballMatchLeftTeamScore: {},
      footballMatchRightTeamScore: {},
      game_events: [],
      selected_indexes: {grp:'', round:'', match:''},
      team_list: [],
      venues: [],
      sets: [0,0,0],
      show_list_view: true,
      selected_zone: "Default",
      zones: [],
      matches: []
    };
    this.updateFixture    = this.updateFixture.bind(this);
    this.handleTeamChange = this.handleTeamChange.bind(this);
    this.ParentCallback   = this.ParentCallback.bind(this);
    this.handleEvent      = this.handleEvent.bind(this);
    this.onZoneChange     = this.onZoneChange.bind(this);

    this.styles = {
      chip:    { margin: 4 },
      wrapper: { display: 'flex', flexWrap: 'wrap' },
    };
  }

  componentDidMount() {
    this.getKnockoutFixtures();
    this.getTournamentTeamDetails();
    this.getTeamList();
  }

  getDataSignature(fixtures, levels) {
    if (!fixtures || fixtures.length === 0) return "empty";
    try {
      return fixtures.map(function(f) {
        var team1 = (f.team_one && f.team_one.id) ? f.team_one.id : "x";
        var team2 = (f.team_two && f.team_two.id) ? f.team_two.id : "x";
        var s1 = (f.team1_scores && f.team1_scores.length) ? f.team1_scores.join(',') : '';
        var s2 = (f.team2_scores && f.team2_scores.length) ? f.team2_scores.join(',') : '';
        return f.id + "-" + f.match_level + "-" + team1 + "-" + team2 + "-" + s1 + "-" + s2;
      }).join('|') + "::" + (levels ? levels.join(',') : '');
    } catch(e) {
      return String(Math.random());
    }
  }

  getKnockoutFixtures() {
    const url = `${getLocationOrigin()}/tournament/get_knockout_competition_matches/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'};
    options['body'] = JSON.stringify({ competition_id: this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .catch(error => { console.log(error); alert(error.message); })
      .then(data => {
        this.setState({levels: data.levels, courts: data.courts, zones: data.zones, matches: data.matches}, () => {
          if (data.levels < 1) {
            alert('Please create knockout-matches first !!');
            this.props.history.goBack();
          } else {
            let fixtures = data.matches.filter(info => info.zone == this.state.selected_zone);
            for (let i = 0; i < fixtures.length; i++) {
              if (fixtures[i].team_one.name != 'BYE' && fixtures[i].team_two.name != 'BYE') {
                if (!fixtures[i]['team1_scores']) fixtures[i]['team1_scores'] = [];
                if (!fixtures[i]['team2_scores']) fixtures[i]['team2_scores'] = [];
              }
            }
            this.setState({fixtures: [...fixtures]});
          }
        });
      });
  }

  getTournamentTeamDetails() {
    const url = `${getLocationOrigin()}/eagleeye/get_match_input_for_competition/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'};
    options['body'] = JSON.stringify({'competition_id': this.state.competition_id});
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ competition_game: data.game, game_events: data.game_events, venues: data.venues }); })
      .catch(error => error);
  }

  updateFixture(index) {
    if (this.state.fixtures[index].team_one.name != 'BYE' && this.state.fixtures[index].team_two.name != 'BYE'
      && this.state.fixtures[index].team_one.name != 'TBD' && this.state.fixtures[index].team_two.name != 'TBD') {
      this.setState({selected_fixture: this.state.fixtures[index], openUpdatePopup: true, selected_fixture_index: index});
    }
  }

  onStartTimeChange(date_time) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    fixtures[this.state.selected_fixture_index].session_start = moment(date_time.toDate()).format("DD/MM/YYYY hh:mm A");
    this.setState({fixtures: fixtures, selected_fixture: fixtures[this.state.selected_fixture_index]});
  }

  handleCourtChange(e) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    fixtures[this.state.selected_fixture_index].court.id = e.target.value;
    this.setState({fixtures: fixtures, selected_fixture: fixtures[this.state.selected_fixture_index]});
  }

  changeScore(e, index, set_key) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    if (e.target.id == 'team1_scores') {
      if (fixtures[index].team1_scores && fixtures[index].team1_scores[set_key] != undefined) {
        fixtures[index].team1_scores[set_key] = e.target.value; fixtures[index]['have_changes'] = true;
      } else if ((fixtures[index].team1_scores.length == 0 && set_key == 0) || (fixtures[index].team1_scores[set_key-1] != undefined)) {
        fixtures[index].team1_scores.push(e.target.value); fixtures[index]['have_changes'] = true;
      } else { alert('Please enter set ' + (set_key).toString() + ' score !!'); }
    } else if (e.target.id == 'team2_scores') {
      if (fixtures[index].team2_scores && fixtures[index].team2_scores[set_key] != undefined) {
        fixtures[index].team2_scores[set_key] = e.target.value; fixtures[index]['have_changes'] = true;
      } else if ((fixtures[index].team2_scores.length == 0 && set_key == 0) || (fixtures[index].team2_scores[set_key-1] != undefined)) {
        fixtures[index].team2_scores.push(e.target.value); fixtures[index]['have_changes'] = true;
      } else { alert('Please enter set ' + (set_key).toString() + ' score !!'); }
    }
    this.setState({fixtures: fixtures, selected_fixture: fixtures[index]});
  }

  deleteFixtures(arr, attr, value) {
    if (confirm("IMPORTANT !!\nAre you sure you want to delete?\nAll fixtures and the scores will be deleted permanently !!") == true) {
      this.confirmDeleteFixtures();
    }
  }

  confirmDeleteFixtures() {
    this.setState({submit_button_pressed: true});
    const url = `${getLocationOrigin()}/tournament/delete_competition_fixtures/`;
    const options = {...defaultOptions};
    options['method'] = 'post'; options['headers'] = {'content-type': 'application/json'};
    options['body'] = JSON.stringify({ competition_id: this.state.competition_id, match_type: 'knockout_matches' });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .catch(error => { console.log(error); alert(error.message); this.setState({submit_button_pressed: false}); })
      .then(data => { alert(data.message); this.setState({submit_button_pressed: false}); this.props.history.goBack(); });
  }

  updateKnockoutMatches(match_id, level, index) {
    this.setState({submit_button_pressed: true});
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    let selected_match = fixtures[index];
    let fetch_break = false;
    let team1_score_arr_len = selected_match.team1_scores.length;
    let team2_score_arr_len = selected_match.team2_scores.length;
    let max_len_score_arr = team1_score_arr_len, max_score_arr = selected_match.team1_scores, min_len_score_arr = team2_score_arr_len;
    if (team2_score_arr_len > team1_score_arr_len) { max_len_score_arr = team2_score_arr_len; min_len_score_arr = team1_score_arr_len; max_score_arr = selected_match.team2_scores; }
    if (selected_match.team1_scores.length != selected_match.team2_scores.length) {
      for (let i = min_len_score_arr; i < max_len_score_arr; i++) {
        if (max_score_arr[i] != '') { fetch_break = true; } else { max_score_arr.splice(i, 1); i--; max_len_score_arr--; }
      }
    }
    for (let i = 0; i < min_len_score_arr; i++) {
      if ((selected_match.team1_scores[i] == '' && selected_match.team2_scores[i] != '') || (selected_match.team1_scores[i] != '' && selected_match.team2_scores[i] == '')) { fetch_break = true; }
    }
    this.setState({fixtures: fixtures}, () => { this.updateMatchConfirm(fetch_break, index); });
  }

  getTeamList() {
    const url = `${getLocationOrigin()}/eagleeye/get_tournament_teams_details/`;
    const options = {...defaultOptions};
    options['method'] = 'post'; options['headers'] = {'content-type': 'application/json'};
    options['body'] = JSON.stringify({'competition_id': this.state.competition_id});
    return fetch(url, options).then(checkStatus).then(parseJSON)
      .then(data => this.setState({team_list: data.teamlist}))
      .catch(error => { console.log(error); alert(error.message); });
  }

  onZoneChange(e) {
    let value = e.target.value;
    let fixtures = this.state.matches.filter(info => info.zone == value).map(match => ({...match}));
    for (let i = 0; i < fixtures.length; i++) {
      if (fixtures[i].team_one.name != 'BYE' && fixtures[i].team_two.name != 'BYE') {
        fixtures[i].team1_scores = fixtures[i].team1_scores || [];
        fixtures[i].team2_scores = fixtures[i].team2_scores || [];
      }
    }
    let levels = [...new Set(fixtures.filter(f => f.match_level !== undefined && f.match_level !== null).map(f => f.match_level))];
    this.setState({ selected_zone: value, fixtures: [...fixtures], levels: [...levels] });
  }

  updateMatchConfirm(fetch_break, selected_fixture_index) {
    let selected_match = this.state.fixtures[selected_fixture_index];
    if ((fetch_break == false && this.state.competition_game.id != 1) || this.state.competition_game.id == 1) {
      const url = `${getLocationOrigin()}/tournament/update_competition_match/`;
      const options = {...defaultOptions};
      options['method'] = 'post'; options['headers'] = {'content-type': 'application/json'};
      options['body'] = JSON.stringify({match_details: selected_match});
      return fetch(url, options).then(checkStatus).then(parseJSON)
        .catch(error => { console.log(error); alert(error.message); this.setState({submit_button_pressed: false}); })
        .then(data => {
          let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
          selected_match = fixtures[selected_fixture_index];
          if (selected_match.team_one.id == data.winner) { selected_match.team_one.winner = true; selected_match.team_two.winner = false; }
          else if (selected_match.team_two.id == data.winner) { selected_match.team_two.winner = true; selected_match.team_one.winner = false; }
          else { selected_match.team_one.winner = false; selected_match.team_two.winner = false; }
          fixtures[parseInt(data.next_match_no)] = data.next_match;
          fixtures[selected_fixture_index]['have_changes'] = false;
          this.setState({submit_button_pressed: false, fixtures: fixtures, openUpdatePopup: false});
          alert(data.message);
        });
    } else { alert('Please enter scores for each team !!'); this.setState({submit_button_pressed: false}); }
  }

  openPopup(level, index) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    fixtures = fixtures.filter(info => info.level == level);
    this.setState({selected_fixture: fixtures[index]}, () => {
      let footballMatchLeftTeamScore  = Object.assign({}, this.state.footballMatchLeftTeamScore);
      let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
      footballMatchLeftTeamScore['match_id']  = this.state.fixtures[index].id;
      footballMatchRightTeamScore['match_id'] = this.state.fixtures[index].id;
      this.setState({
        openUpdatePopup: false, openPopupFootballScoreScreen: true,
        selected_fixture: this.state.fixtures[index],
        selectedEvent: '', leftOpen: false, rightOpen: false,
        footballMatchRightTeamScore, footballMatchLeftTeamScore
      });
    });
  }

  handleTeamChange(e, level, index, team_position) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    if (team_position == "team_one") { fixtures[index]['team_one']['id'] = e.target.value; fixtures[index]['team_one']['name'] = ''; fixtures[index]['team_one']['logo'] = ''; }
    else { fixtures[index]['team_two']['id'] = e.target.value; fixtures[index]['team_two']['name'] = ''; fixtures[index]['team_two']['logo'] = ''; }
    fixtures[index]['have_changes'] = true;
    this.setState({fixtures: fixtures});
  }

  handleFixtureVenue(e, level, index) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    fixtures[index]['venue_id'] = e.target.value; fixtures[index]['have_changes'] = true;
    this.setState({fixtures: fixtures});
  }

  handleDateTimePicker(date_time, level, index) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    fixtures[index]['session_start'] = moment(date_time.toDate()).format("DD/MM/YYYY hh:mm A");
    fixtures[index]['have_changes']  = true;
    this.setState({fixtures: fixtures});
  }

  deleteEventHistory(event_activity_id, side) {
    if (confirm("Are you sure you want delete?") == true) { this.confirmDeleteEventHistory(event_activity_id, side); }
  }

  confirmDeleteEventHistory(event_activity_id, side) {
    this.setState({submit_button_pressed: true});
    const url = `${getLocationOrigin()}/tournament/delete_football_event_activity/`;
    const options = {...defaultOptions};
    options['method'] = 'post'; options['headers'] = {'content-type': 'application/json'};
    options['body'] = JSON.stringify({'event_activity_id': event_activity_id, 'team_side': side});
    return fetch(url, options).then(checkStatus).then(parseJSON)
      .then(data => {
        let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
        let current_fixtures = JSON.parse(JSON.stringify(this.state.selected_fixture));
        current_fixtures.team1_scores[0] = parseInt(data.team1_scores);
        current_fixtures.team2_scores[0] = parseInt(data.team2_scores);
        current_fixtures.match_events    = data.match_events;
        current_fixtures['have_changes'] = true;
        fixtures[this.state.selected_fixture_index] = current_fixtures;
        this.setState({selected_fixture: current_fixtures, fixtures: fixtures, submit_button_pressed: false});
      })
      .catch(error => error);
  }

  handleChangePlayer(e, side) {
    if (side == 'left') {
      let s = Object.assign({}, this.state.footballMatchLeftTeamScore);
      s['player_id'] = e.target.value; s['team_id'] = this.state.selected_fixture.team_one.id;
      s['event'] = this.state.selectedEvent.id; s['side'] = 'left';
      this.setState({footballMatchLeftTeamScore: s});
    } else if (side == 'right') {
      let s = Object.assign({}, this.state.footballMatchRightTeamScore);
      s['player_id'] = e.target.value; s['team_id'] = this.state.selected_fixture.team_two.id;
      s['event'] = this.state.selectedEvent.id; s['side'] = 'right';
      this.setState({footballMatchRightTeamScore: s});
    }
  }

  changeEventTime(e, side) {
    if (side == 'left') {
      let s = Object.assign({}, this.state.footballMatchLeftTeamScore);
      s['event_time'] = e.target.value; this.setState({footballMatchLeftTeamScore: s});
    } else if (side == 'right') {
      let s = Object.assign({}, this.state.footballMatchRightTeamScore);
      s['event_time'] = e.target.value; this.setState({footballMatchRightTeamScore: s});
    }
  }

  updateFootballScore(side) {
    let eventObj = side == 'left' ? this.state.footballMatchLeftTeamScore : this.state.footballMatchRightTeamScore;
    const url = `${getLocationOrigin()}/tournament/update_football_match_event/`;
    const options = {...defaultOptions};
    options['method'] = 'post'; options['headers'] = {'content-type': 'application/json'};
    options['body'] = JSON.stringify({'match_event': eventObj});
    return fetch(url, options).then(checkStatus).then(parseJSON)
      .then(data => {
        let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
        let fixture_index = fixtures.findIndex(info => info.id == this.state.selected_fixture.id);
        let current_fixtures = JSON.parse(JSON.stringify(this.state.selected_fixture));
        current_fixtures.team1_scores[0] = parseInt(data.team1_scores);
        current_fixtures.team2_scores[0] = parseInt(data.team2_scores);
        current_fixtures.match_events    = data.match_events;
        fixtures[fixture_index] = current_fixtures;
        this.setState({selected_fixture: current_fixtures, fixtures});
        if (side == 'left') this.setState({leftOpen: false}); else this.setState({rightOpen: false});
      })
      .catch(error => error);
  }

  handleEvent(event, dir) {
    this.setState({selectedEvent: event, openPlayerList: true, teamSide: dir}, () => {
      if (dir == 'left') {
        let s = Object.assign({}, this.state.footballMatchLeftTeamScore);
        s['team_id'] = this.state.selected_fixture.team_one.id; s['player_id'] = ''; s['event'] = this.state.selectedEvent.id; s['side'] = 'left';
        this.setState({footballMatchLeftTeamScore: s, leftOpen: true});
      }
      if (dir == 'right') {
        let s = Object.assign({}, this.state.footballMatchRightTeamScore);
        s['player_id'] = ''; s['team_id'] = this.state.selected_fixture.team_two.id; s['event'] = this.state.selectedEvent.id; s['side'] = 'right';
        this.setState({footballMatchRightTeamScore: s, rightOpen: true});
      }
    });
  }

  // ─── One team column: pills + form + history ─────────────────────────────────
  renderTeamEventColumn(dir) {
    var self   = this;
    var fix    = this.state.selected_fixture;
    var isLeft = dir == 'left';
    var team   = isLeft ? fix.team_one : fix.team_two;
    var scoreObj    = isLeft ? this.state.footballMatchLeftTeamScore : this.state.footballMatchRightTeamScore;
    var isOpen      = isLeft ? this.state.leftOpen  : this.state.rightOpen;
    var teamMatchObj = this.state.team_list.filter(t => t.id == team.id)[0];
    var teamEvents   = (fix.match_events || []).filter(e => e.team && e.team.id == team.id);
    var selEvt       = (this.state.selectedEvent && isOpen) ? this.state.selectedEvent : null;
    var selMeta      = selEvt ? getEventMeta(selEvt.event) : null;

    var inputSt = { width: '100%', boxSizing: 'border-box', borderRadius: 8, border: '1.5px solid #d1d5db', padding: '8px 10px', fontSize: 13, fontFamily: FF, outline: 'none', background: '#fff' };
    var labelSt = { fontSize: 11, color: '#6b7280', display: 'block', marginBottom: 3, fontWeight: 600, fontFamily: FF };

    return (
      <div>
        {/* Team label */}
        <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 9, fontFamily: FF }}>
          {team.name}
        </div>

        {/* Event type pills */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 8 }}>
          {this.state.game_events.map(function(ev, i) {
            var meta     = getEventMeta(ev.event);
            var isActive = isOpen && self.state.selectedEvent && self.state.selectedEvent.id === ev.id;
            return (
              <button key={i} type="button"
                onClick={function() { self.handleEvent(ev, dir); }}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '5px 11px', borderRadius: 20, border: '1.5px solid ' + (isActive ? meta.color : '#e5e7eb'), background: isActive ? meta.bg : '#fff', color: isActive ? meta.color : '#374151', fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: FF, transition: 'all 0.14s' }}>
                <span>{meta.emoji}</span> {ev.event}
              </button>
            );
          })}
        </div>

        {/* Event input form — only when a pill is active */}
        {selEvt && selMeta && (
          <div style={{ background: selMeta.bg, border: '1px solid ' + selMeta.border, borderRadius: 12, padding: '12px 14px', marginBottom: 10, position: 'relative' }}>
            {/* Dismiss X */}
            <button type="button"
              onClick={function() { self.setState(isLeft ? {leftOpen: false, selectedEvent: ''} : {rightOpen: false, selectedEvent: ''}); }}
              style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', cursor: 'pointer', padding: 2, lineHeight: 1 }}>
              <svg width={12} height={12} viewBox="0 0 14 14" fill="none">
                <path d="M2 2l10 10M12 2L2 12" stroke={selMeta.color} strokeWidth="2.2" strokeLinecap="round"/>
              </svg>
            </button>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6, fontFamily: FF }}>
              <span style={{ fontSize: 15 }}>{selMeta.emoji}</span> {selEvt.event}
            </div>
            <div style={{ marginBottom: 8 }}>
              <label style={labelSt}>Player</label>
              <select value={scoreObj['player_id'] || ''} onChange={function(e) { self.handleChangePlayer(e, dir); }} style={inputSt}>
                <option value="">Select player…</option>
                {teamMatchObj && teamMatchObj.players && teamMatchObj.players.map(function(p, i) {
                  return <option key={i} value={p.id}>{p.name}</option>;
                })}
              </select>
            </div>
            <div style={{ marginBottom: 10 }}>
              <label style={labelSt}>Minute</label>
              <input type="number" min="0" max="120" placeholder="e.g. 45" value={scoreObj['event_time'] || ''} onChange={function(e) { self.changeEventTime(e, dir); }} style={inputSt} />
            </div>
            <button type="button"
              style={{ width: '100%', background: PURPLE, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 0', fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: FF }}
              onClick={function() { self.setState({selectedEvent: ''}, function() { self.updateFootballScore(dir); }); }}>
              {selMeta.emoji} Log {selEvt.event}
            </button>
          </div>
        )}

        {/* Event history pills */}
        <div style={{ marginTop: 4 }}>
          {teamEvents.length === 0
            ? <div style={{ fontSize: 12, color: '#9ca3af', fontFamily: FF }}>No events logged yet</div>
            : teamEvents.map(function(info) {
                var evName = info.game_event ? info.game_event.name : '';
                var meta   = getEventMeta(evName);
                return (
                  <div key={info.id} style={{ display: 'flex', alignItems: 'center', gap: 8, background: meta.bg, border: '1px solid ' + meta.border, borderRadius: 24, padding: '5px 8px 5px 10px', marginBottom: 6 }}>
                    <img src={getEventIcon(evName)} alt="" style={{ width: 20, height: 20, flexShrink: 0 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: '#111827', fontFamily: FF, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {info.player ? info.player.name : '—'}
                      </div>
                      {info.event_time && <div style={{ fontSize: 11, color: meta.color, fontWeight: 600, fontFamily: FF }}>{info.event_time}&apos;</div>}
                    </div>
                    <button type="button" onClick={function() { self.deleteEventHistory(info.id, dir); }}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: meta.color, display: 'flex', alignItems: 'center', borderRadius: 4, flexShrink: 0 }}>
                      <svg width={11} height={11} viewBox="0 0 14 14" fill="none">
                        <path d="M2 2l10 10M12 2L2 12" stroke={meta.color} strokeWidth="2.2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                );
              })
          }
        </div>
      </div>
    );
  }

  // ─── NEW renderKnockoutScorePopup — same visual language as ScoreboardDialogs ─
  renderKnockoutScorePopup() {
    if (!this.state.openPopupFootballScoreScreen || !this.state.selected_fixture) return null;
    var self = this;
    var fix  = this.state.selected_fixture;
    var t1   = fix.team_one;
    var t2   = fix.team_two;
    var s1   = fix.team1_scores && fix.team1_scores[0] != null ? fix.team1_scores[0] : 0;
    var s2   = fix.team2_scores && fix.team2_scores[0] != null ? fix.team2_scores[0] : 0;
    var isDraw  = !t1.winner && !t2.winner && Number(s1) === Number(s2);
    var AMBER   = "#f59e0b";
    var scoreC1 = isDraw ? AMBER : (t1.winner ? PURPLE : '#111827');
    var scoreC2 = isDraw ? AMBER : (t2.winner ? PURPLE : '#111827');

    function teamLogo(team, size) {
      var src = team.logo
        ? (team.logo.includes('http') ? team.logo : 'https://api.sporthood.in' + team.logo)
        : null;
      if (src) {
        return <img src={src} alt={team.name} style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', border: '3px solid #e5e7eb', boxShadow: '0 2px 10px rgba(0,0,0,0.10)', background: '#f3f4f6', display: 'block' }} />;
      }
      return (
        <div style={{ width: size, height: size, borderRadius: '50%', background: PURPLE, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.38, fontWeight: 900, color: '#fff', border: '3px solid #e5e7eb', flexShrink: 0 }}>
          {(team.name || '?').charAt(0).toUpperCase()}
        </div>
      );
    }

    return (
      // Backdrop
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,10,30,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9000, padding: 20 }}
        onClick={function() { self.setState({openPopupFootballScoreScreen: false, selectedEvent: '', leftOpen: false, rightOpen: false}); }}>

        {/* Modal */}
        <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 780, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 24px 64px rgba(0,0,0,0.24)', fontFamily: FF, position: 'relative' }}
          onClick={function(e) { e.stopPropagation(); }}>

          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', borderBottom: '1px solid #f3f4f6', position: 'sticky', top: 0, background: '#fff', zIndex: 5, borderRadius: '20px 20px 0 0' }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: '#111827', fontFamily: FF }}>Match Scoreboard</span>
            <button type="button"
              onClick={function() { self.setState({openPopupFootballScoreScreen: false, selectedEvent: '', leftOpen: false, rightOpen: false}); }}
              style={{ background: '#f3f4f6', border: 'none', borderRadius: '50%', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}>
              <svg width={13} height={13} viewBox="0 0 14 14" fill="none">
                <path d="M2 2l10 10M12 2L2 12" stroke="#374151" strokeWidth="2.2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

          {/* Score banner */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, background: 'linear-gradient(135deg,#faf5ff,#f0f9ff)', borderBottom: '1px solid #f3f4f6', padding: '24px 32px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, flex: 1 }}>
              {teamLogo(t1, 80)}
              <div style={{ fontSize: 14, fontWeight: 700, color: '#111827', textAlign: 'center', fontFamily: FF }}>
                {t1.name}
                {t1.winner && <div style={{ fontSize: 10, color: PURPLE, fontWeight: 700, marginTop: 2 }}>Winner ★</div>}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <span style={{ fontSize: 68, fontWeight: 900, color: scoreC1, lineHeight: 1 }}>{s1}</span>
                <span style={{ fontSize: 28, color: '#9ca3af', fontWeight: 700 }}>–</span>
                <span style={{ fontSize: 68, fontWeight: 900, color: scoreC2, lineHeight: 1 }}>{s2}</span>
              </div>
              {isDraw && <div style={{ fontSize: 12, fontWeight: 700, color: AMBER, background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 20, padding: '3px 14px', fontFamily: FF }}>🤝 Draw</div>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, flex: 1 }}>
              {teamLogo(t2, 80)}
              <div style={{ fontSize: 14, fontWeight: 700, color: '#111827', textAlign: 'center', fontFamily: FF }}>
                {t2.name}
                {t2.winner && <div style={{ fontSize: 10, color: PURPLE, fontWeight: 700, marginTop: 2 }}>Winner ★</div>}
              </div>
            </div>
          </div>

          {/* Two-column event section */}
          <div style={{ display: 'flex', alignItems: 'stretch' }}>
            <div style={{ flex: 1, minWidth: 0, padding: '20px 22px', borderRight: '1px solid #f3f4f6' }}>
              {this.renderTeamEventColumn('left')}
            </div>
            <div style={{ flex: 1, minWidth: 0, padding: '20px 22px' }}>
              {this.renderTeamEventColumn('right')}
            </div>
          </div>

        </div>
      </div>
    );
  }

  renderKnockout() {
    var schedule = this.state.fixtures;
    var self = this;
    var scoreInputStyle = { width: 48, padding: '5px 4px', border: '1px solid ' + colors.border, borderRadius: 6, fontSize: 12, textAlign: 'center', fontFamily: 'inherit', color: colors.text, background: colors.bg, outline: 'none', boxSizing: 'border-box' };

    return (
      <div>
        {self.state.levels.map(function(level, levelIdx) {
          return (
            <div key={levelIdx} style={Object.assign({}, card.wrap, { marginBottom: 24 })}>
              <div style={card.header}><h3 style={card.title}>{level}</h3></div>
              <div style={{ overflowX: 'auto' }}>
                <table style={table.table}>
                  <thead>
                    <tr>
                      <th style={table.th}>Team 1</th><th style={table.th}>Team 2</th>
                      <th style={table.th}>Date / Time</th>
                      <th style={Object.assign({}, table.th, { textAlign: 'center' })}>Score</th>
                      <th style={Object.assign({}, table.th, { textAlign: 'center', width: 80 })}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {schedule && schedule.map(function(match, key) {
                      if (match.match_level != level) return null;
                      var isBye    = match.team_one.name === 'BYE' || match.team_two.name === 'BYE';
                      var hasScore = match.team1_scores && match.team1_scores.length;
                      return (
                        <tr key={key} style={key % 2 === 1 ? table.trAlt : {}}>
                          <td style={table.td}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              {match.team_one.winner && <span style={{ color: colors.brand, display: 'flex', alignItems: 'center', flexShrink: 0 }}><IconTrophy size={14} /></span>}
                              <select name="team_one" style={Object.assign({}, form.select, { flex: 1, minWidth: 0, fontSize: 12, padding: '6px 8px' })} value={match.team_one.id} onChange={function(e) { self.handleTeamChange(e, level, key, 'team_one'); }}>
                                <option value="">—</option>
                                {self.state.team_list.map(function(t, i) { return <option key={i} value={t.id}>{t.team.name}</option>; })}
                              </select>
                            </div>
                          </td>
                          <td style={table.td}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <select name="team_two" style={Object.assign({}, form.select, { flex: 1, minWidth: 0, fontSize: 12, padding: '6px 8px' })} value={match.team_two.id} onChange={function(e) { self.handleTeamChange(e, level, key, 'team_two'); }}>
                                <option value="">—</option>
                                {self.state.team_list.map(function(t, i) { return <option key={i} value={t.id}>{t.team.name}</option>; })}
                              </select>
                              {match.team_two.winner && <span style={{ color: colors.brand, display: 'flex', alignItems: 'center', flexShrink: 0 }}><IconTrophy size={14} /></span>}
                            </div>
                          </td>
                          <td style={table.td}>
                            {!isBye && <Datetime inputProps={{ className: 'datetime', style: Object.assign({}, form.input, { width: 150, fontSize: 12, padding: '6px 8px' }) }} dateFormat="DD/MM/YYYY" onChange={function(date) { self.handleDateTimePicker(date, level, key); }} value={match.session_start} />}
                          </td>
                          <td style={Object.assign({}, table.td, { textAlign: 'center' })}>
                            {!isBye && self.state.competition_game && (
                              self.state.competition_game.id != 1 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'center' }}>
                                  {['', '', ''].map(function(_, setIdx) {
                                    return (
                                      <div key={setIdx} style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                        <input type="text" placeholder={'T1'} id="team1_scores" style={scoreInputStyle} onChange={function(e) { self.changeScore(e, key, setIdx); }} value={match.team1_scores[setIdx] || ''} />
                                        <span style={{ color: colors.muted, fontSize: 11 }}>–</span>
                                        <input type="text" placeholder={'T2'} id="team2_scores" style={scoreInputStyle} onChange={function(e) { self.changeScore(e, key, setIdx); }} value={match.team2_scores[setIdx] || ''} />
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <button style={Object.assign({}, hasScore ? btn.primarySm : btn.outlineSm, { fontFamily: 'inherit' })} onClick={function() { self.openPopup(level, key); }}>
                                  {hasScore ? (match.team1_scores[0] + ' – ' + (match.team2_scores[0] || 0)) : 'Add Score'}
                                </button>
                              )
                            )}
                          </td>
                          <td style={Object.assign({}, table.td, { textAlign: 'center' })}>
                            {(match.team_one.name !== 'BYE' || match.team_two.name !== 'BYE') && (
                              <button disabled={self.state.submit_button_pressed || !match.have_changes}
                                style={Object.assign({}, match.have_changes ? btn.primarySm : btn.outlineSm, { fontFamily: 'inherit', opacity: (self.state.submit_button_pressed || !match.have_changes) ? 0.5 : 1 })}
                                onClick={function() { self.updateKnockoutMatches(match.id, level, key); }}>
                                {match.have_changes ? 'Save' : 'Saved'}
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  ParentCallback() { this.setState({show_list_view: false}); }

  render() {
    var knockoutKey    = this.getDataSignature(this.state.fixtures, this.state.levels);
    var show_list_view = this.state.show_list_view;
    var self = this;

    var pageHeader = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 20px', background: colors.surface, borderBottom: '1px solid ' + colors.border, flexWrap: 'wrap', gap: 10, position: 'sticky', top: 0, zIndex: 100, boxShadow: shadows.card };
    var backBtn    = Object.assign({}, btn.cancel,    { fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: 6 });
    var toggleBtn  = Object.assign({}, btn.outlineSm, { fontFamily: 'inherit' });
    var deleteBtn  = Object.assign({}, btn.danger,    { fontFamily: 'inherit', opacity: this.state.submit_button_pressed ? 0.6 : 1 });
    var zoneSelect = Object.assign({}, form.select,   { minWidth: 140, fontFamily: 'inherit' });

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", minHeight: '100vh', background: colors.bg }}>
        <div style={pageHeader}>
          <button style={backBtn} onClick={function() { self.props.history.goBack(); }}><IconArrowLeft size={14} /> Back</button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            {this.state.zones && this.state.zones.length > 1 && (
              <select value={this.state.selected_zone} onChange={function(e) { self.onZoneChange(e); }} style={zoneSelect}>
                {this.state.zones.map(function(zone, index) { return <option key={index} value={zone.name}>{zone.name}</option>; })}
              </select>
            )}
            <button style={toggleBtn} onClick={function() { self.setState({ show_list_view: !show_list_view }); }}>
              {show_list_view
                ? <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><IconBracket size={14} /> Bracket View</span>
                : <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}><IconList size={14} /> List View</span>}
            </button>
            <button disabled={this.state.submit_button_pressed} style={deleteBtn} onClick={function() { self.deleteFixtures(); }} type="button">Delete Fixtures</button>
          </div>
        </div>

        <div style={{ padding: '20px' }}>
          {!show_list_view ? (
            <div style={{ background: 'linear-gradient(135deg, #faf5ff 0%, #f0f9ff 100%)', borderRadius: 16, border: '1px solid #ede9fe', padding: '24px 16px 16px', boxShadow: '0 4px 24px rgba(124,58,237,0.06)', overflowX: 'auto' }}>
              {this.state.levels && this.state.levels.length > 0 && (
                <div style={{ display: 'flex', marginBottom: 12, paddingLeft: 24, gap: 0 }}>
                  {this.state.levels.slice().reverse().map(function(level, i) {
                    return (
                      <div key={i} style={{ width: 276, flexShrink: 0, textAlign: 'center' }}>
                        <span style={{ display: 'inline-block', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#7c3aed', background: '#f5f3ff', border: '1px solid #ede9fe', borderRadius: 20, padding: '3px 12px' }}>{level}</span>
                      </div>
                    );
                  })}
                </div>
              )}
              <KnockoutView key={knockoutKey} ParentCallback={this.ParentCallback} competition_id={this.state.competition_id} fixtures={this.state.fixtures} levels={this.state.levels} courts={this.state.courts} />
              <div style={{ textAlign: 'center', marginTop: 12, fontSize: 11, color: '#a78bfa', fontWeight: 500, letterSpacing: '0.02em' }}>Click any match card to view or update details</div>
            </div>
          ) : (
            <div>
              {this.state.fixtures.length > 0 && this.renderKnockout()}
              {this.renderKnockoutScorePopup()}
              {this.state.fixtures.length < 1 && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40vh' }}>
                  <Spinner name="line-scale-pulse-out-rapid" color={colors.brand} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default viewKnockoutScreen;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewKnockoutScreen/index.js